import { request } from "hooks/useOkoApi/useOkoApi";

const BASE = "school-reports";

const buildQuery = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const fetchScope = () => request(`${BASE}/scope`, { method: "GET" });

export const fetchSchools = () =>
  request(`${BASE}/filters/schools`, { method: "GET" });

export const fetchTeachers = ({ schoolId, startDate, endDate } = {}) =>
  request(
    `${BASE}/filters/teachers${buildQuery({
      school_id: schoolId,
      start_date: startDate,
      end_date: endDate,
    })}`,
    { method: "GET" }
  );

const reportPath = (slug, params) => `${BASE}/${slug}${buildQuery(params)}`;

const fetchReportJson = async (slug, params) => {
  const data = await request(reportPath(slug, { ...params, format: "json" }), {
    method: "GET",
  });
  const rows = Array.isArray(data?.rows) ? data.rows : [];
  // Only Proficiency carries `domains`; the other reports get an empty list.
  const domains = Array.isArray(data?.domains) ? data.domains : [];
  return { rows, rowCount: data?.row_count ?? rows.length, domains };
};

const fetchReportCsv = (slug, params) =>
  request(reportPath(slug, { ...params, format: "csv" }), { method: "GET" });

export const fetchTeacherSummary = (params) =>
  fetchReportJson("teacher-summary", params);
export const downloadTeacherSummaryCSV = (params) =>
  fetchReportCsv("teacher-summary", params);

export const fetchDosageTrend = (params) =>
  fetchReportJson("dosage-trend", params);
export const downloadDosageTrendCSV = (params) =>
  fetchReportCsv("dosage-trend", params);

export const fetchStudentCollabTrend = (params) =>
  fetchReportJson("student-collab-trend", params);
export const downloadStudentCollabTrendCSV = (params) =>
  fetchReportCsv("student-collab-trend", params);

export const fetchStudentProficiency = (params) =>
  fetchReportJson("student-proficiency", params);
export const downloadStudentProficiencyCSV = (params) =>
  fetchReportCsv("student-proficiency", params);
